import { connect } from 'react-redux'
import { selectContactOptions } from '../ContactUsModal/selectors'
import { MoreHelpFooter } from '../../components'
import { createEvent } from '../UserEvents/actions'

const mapStateToProps = (state, ownProps) => ({
  contactOptions: selectContactOptions(state),
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MoreHelpFooter)



// WEBPACK FOOTER //
// ./src/containers/MoreHelpFooter/MoreHelpFooter.js